const itemsRaw = [
  {
    id: 'B01KLNIT0S',
    title:
      'Amazon.com: Panasonic KX-TGC352B Expandable Cordless Phone with Amber Backlit Display - 2 Handsets, Black: PANASONIC: Office Products',
    url:
      'https://www.amazon.com/Panasonic-KX-TGC352B-Expandable-Cordless-Backlit/dp/B01KLNIT0S',
    largestImageUrl: '91qHbXq3fSL._SL1500_.jpg',
    categories: [
      'Office Products',
      'Office Electronics',
      'Telephones & Accessories',
      'Landline Phones',
      'Cordless Telephones',
    ],
    endCategory: 'Cordless Telephones',
    shortName: 'Cordless Telephone',
    priceRaw: '$34.99',
    price: 34.99,
  },
  {
    id: 'B0176RILZU',
    title:
      "Amazon.com: People's Choice Beef Jerky - Old Fashioned - Hot & Spicy - Sugar-Free, Carb-Free, Keto-Friendly - 1 Pound, 1 Bag",
    url:
      'https://www.amazon.com/Peoples-Choice-Beef-Jerky-Keto-Friendly/dp/B0176RILZU',
    largestImageUrl: '91UHDKh3kEL._SL1500_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Snack Foods',
      'Jerky & Dried Meats',
    ],
    endCategory: 'Jerky & Dried Meats',
    shortName: 'Jerky & Dried Meat',
    priceRaw: '$25.99',
    price: 25.99,
  },

  {
    id: 'B00006JNNE',
    title:
      "Amazon.com : Post-it Notes, America's #1 Favorite Sticky Note, 3 in x 3 in, Canary Yellow, 12 Pads/Pack, 100 Sheets/Pad : Sticky Note Pads : Office Products",
    url:
      'https://www.amazon.com/Post-Americas-Favorite-Sticky-Canary/dp/B00006JNNE',
    largestImageUrl: '61irwTV2BW8L._SL1500_.jpg',
    categories: [
      'Office Products',
      'Office & School Supplies',
      'Paper',
      'Notebooks & Writing Pads',
      'Self-Stick Notes',
    ],
    endCategory: 'Self-Stick Notes',
    shortName: 'Self-Stick Note',
    priceRaw: '$9.99',
    price: 9.99,
  },
  {
    id: 'B0000TQEQA',
    title:
      'Amazon.com: Lynk Sports Rack Adjustable Hooks - Sports Equipment Organizer - Sports Gear Storage: Home & Kitchen',
    url:
      'https://www.amazon.com/Lynk-Sports-Rack-Adjustable-Hooks/dp/B0000TQEQA',
    largestImageUrl: '91ewFNaNF1L._SL1500_.jpg',
    categories: [
      'Tools & Home Improvement',
      'Storage & Home Organization',
      'Garage Storage',
      'Storage Racks',
    ],
    endCategory: 'Storage Racks',
    shortName: 'Storage Rack',
    priceRaw: '$33.99',
    price: 33.99,
  },
  {
    id: 'B0001QNGHC',
    title:
      'Amazon.com: WalterDrake Lettuce KeeperTM - 7" X 8": Kitchen & Dining',
    url: 'https://www.amazon.com/WalterDrake-Lettuce-KeeperTM/dp/B0001QNGHC',
    largestImageUrl: '51g6QBnyqwL._SL1000_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Storage & Organization',
      'Food Storage',
    ],
    endCategory: 'Food Storage',
    shortName: 'Food Storage',
    priceRaw: '$12.52',
    price: 12.52,
  },
  {
    id: 'B000J2EN4S',
    title:
      'Amazon.com: Belkin BE112230-08 12-Outlet Power Strip Surge Protector: Home Audio & Theater',
    url:
      'https://www.amazon.com/Belkin-BE112230-08-12-Outlet-Power-Protector/dp/B000J2EN4S',
    largestImageUrl: '61B50z1-b7L._SL1500_.jpg',
    categories: [
      'Electronics',
      'Accessories & Supplies',
      'Power Strips & Surge Protectors',
      'Power Strips',
    ],
    endCategory: 'Power Strips',
    shortName: 'Power Strip',
    priceRaw: '$18.99',
    price: 18.99,
  },
  {
    id: 'B0016KA9PY',
    title:
      'Amazon.com: Reese Towpower (74642) Brakeman Timed Compact Brake Control: Automotive',
    url:
      'https://www.amazon.com/Reese-Towpower-74642-Brakeman-Compact/dp/B0016KA9PY',
    largestImageUrl: '616bk1eP9CL._SL1500_.jpg',
    categories: [],
    endCategory: 'Automotive',
    shortName: 'Automotive',
    priceRaw: '$24.17',
    price: 24.17,
  },
  {
    id: 'B000M671VS',
    title: 'Amazon.com: Banana Bunting Costume (3-9 Months): Clothing',
    url: 'https://www.amazon.com/Rasta-Imposta-Banana-Bunting/dp/B00C3DI61W',
    largestImageUrl: '5153-pKPadL._UL1000_.jpg',
    categories: [
      'Clothing, Shoes & Jewelry',
      'Costumes & Accessories',
      'Kids & Baby',
      'Baby',
      'Baby Girls',
    ],
    endCategory: 'Baby Girls',
    shortName: 'Baby Girl',
    priceRaw: '20.44',
    price: 20.44,
  },
  {
    id: 'B000NP79YM',
    title:
      'Amazon.com: HEAROS Xtreme Protection Noise Cancelling Disposable Foam Earplugs NRR 33 Hearing Protection: Health & Personal Care',
    url:
      'https://www.amazon.com/Protection-Cancelling-Disposable-Earplugs-Hearing/dp/B000NP79YM',
    largestImageUrl: '61WuyY5WZZL._SL1000_.jpg',
    categories: ['Health & Household', 'Health Care'],
    endCategory: 'Health Care',
    shortName: 'Health Care',
    priceRaw: '$5.97',
    price: 5.97,
  },
  {
    id: 'B00004TWLZ',
    title:
      'Amazon.com : Fujifilm 1068620 Superia X-TRA 400 35mm Film - 4x24 exp, (Discontinued by Manufacturer) : Photographic Film : Camera & Photo',
    url:
      'https://www.amazon.com/Fujifilm-1068620-Superia-X-TRA-400/dp/B00004TWLZ',
    largestImageUrl: '91w-2Be2PjzL._SL1500_.jpg',
    categories: ['Electronics', 'Camera & Photo', 'Film Photography', 'Film'],
    endCategory: 'Film',
    shortName: 'Film',
    priceRaw: '$22.99',
    price: 22.99,
  },
  {
    id: 'B000P1KSHO',
    title:
      'Amazon.com : HQ VHS-C Video Cassette Adaptor - NOT COMPATIBLE WITH 8mm/MiniDV/Hi8 Tapes ! : Camera & Photo',
    url:
      'https://www.amazon.com/VHS-C-Video-Cassette-Adaptor-COMPATIBLE/dp/B000P1KSHO',
    largestImageUrl: '61laOGjxzeL._SL1280_.jpg',
    categories: ['Electronics', 'Accessories & Supplies', 'Blank Media'],
    endCategory: 'Blank Media',
    shortName: 'Blank Media',
    priceRaw: '$28.90',
    price: 28.9,
  },
  {
    id: 'B000UOJYT4',
    title:
      'Amazon.com | Wilton 14-Inch Round Silver Cake Circles, 2-Count - Cake Bases: Cake Boxes: Cake Stands',
    url:
      'https://www.amazon.com/Wilton-14-Inch-Silver-Circles-2-Count/dp/B000UOJYT4',
    largestImageUrl: '61GvUHO8qaL._SL1200_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Dining & Entertaining',
      'Serveware',
      'Cake Stands',
    ],
    endCategory: 'Cake Stands',
    shortName: 'Cake Stand',
    priceRaw: '$9.23',
    price: 9.23,
  },
  {
    id: 'B00266QVX6',
    title:
      "Amazon.com: The Art of Shaving Men's Pure Badger Shaving Brush, Ivory: Luxury Beauty",
    url: 'https://www.amazon.com/Art-Shaving-Badger-Brush-Ivory/dp/B00266QVX6',
    largestImageUrl: '81fGda4FUeL._SL1500_.jpg',
    categories: [],
    endCategory: 'Luxury Beauty',
    shortName: 'Luxury Beauty',
    priceRaw: '$60.00',
    price: 60,
  },
  {
    id: 'B002G11GOA',
    title:
      'Amazon.com: STA-BIL 360 22241 Marine with Vapor Technology, 10 oz.: Automotive',
    url:
      'https://www.amazon.com/STA-BIL-22241-Marine-Vapor-Technology/dp/B002G11GOA',
    largestImageUrl: '81m67Q8JMRL._SL1500_.jpg',
    categories: [
      'Automotive',
      'Oils & Fluids',
      'Additives',
      'Fuel System',
      'Diesel Additives',
    ],
    endCategory: 'Diesel Additives',
    shortName: 'Diesel Additive',
    priceRaw: '13.17',
    price: 13.17,
  },
  {
    id: 'B00005NCWQ',
    title:
      'Amazon.com: Farberware Classic Stainless Steel Yosemite 8-Cup Coffee Percolator: Kitchen & Dining',
    url:
      'https://www.amazon.com/Farberware-Classic-Stainless-Yosemite-Percolator/dp/B00005NCWQ',
    largestImageUrl: '61NyHF-5BQL._SL1500_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Coffee, Tea & Espresso',
      'Coffee Makers',
      'Percolators',
    ],
    endCategory: 'Percolators',
    shortName: 'Percolator',
    priceRaw: '$18.99',
    price: 18.99,
  },
  {
    id: 'B002QSIUUG',
    title:
      'Amazon.com : Ultra-Star 175G Ultimate Disc - White : Disc Golf Drivers : Sports & Outdoors',
    url: 'https://www.amazon.com/Discraft-gram-Ultra-Star-Sport/dp/B007CZLABY',
    largestImageUrl: '81IvoLxr2B0L._SL1500_.jpg',
    categories: [
      'Sports & Outdoors',
      'Sports & Fitness',
      'Leisure Sports & Game Room',
      'Outdoor Games & Activities',
      'Disc Sports',
      'Flying Discs',
    ],
    endCategory: 'Flying Discs',
    shortName: 'Flying Disc',
    priceRaw: '$9.05',
    price: 9.05,
  },
  {
    id: 'B003PWS9AI',
    title:
      'Amazon.com: SafeRest Twin Size Premium Hypoallergenic Waterproof Mattress Protector - Vinyl Free: Home & Kitchen',
    url:
      'https://www.amazon.com/SafeRest-Hypoallergenic-Waterproof-Mattress-Protector/dp/B003PWS9AI',
    largestImageUrl: '71vbQ0hLE1L._SL1002_.jpg',
    categories: [
      'Home & Kitchen',
      'Bedding',
      'Mattress Pads & Protectors',
      'Mattress Protectors',
    ],
    endCategory: 'Mattress Protectors',
    shortName: 'Mattress Protector',
    priceRaw: '$24.95',
    price: 24.95,
  },
  {
    id: 'B003VWXZKG',
    title:
      'Amazon.com: SINGER | Heavy Duty 4411 Sewing Machine with 11 Built-in Stitches, Metal Frame and Stainless Steel BedPlate, Great for Sewing all Fabrics',
    url:
      'https://www.amazon.com/SINGER-4411-Stitches-Stainless-BedPlate/dp/B003VWXZKG',
    largestImageUrl: '719cgfdqajL._SL1500_.jpg',
    categories: ['Arts, Crafts & Sewing', 'Sewing', 'Sewing Machines'],
    endCategory: 'Sewing Machines',
    shortName: 'Sewing Machine',
    priceRaw: '128.57',
    price: 128.57,
  },
  {
    id: 'B00416WHV4',
    title:
      'Amazon.com: Casio SA76 44 mini Sized Keys 100 Tones: Musical Instruments',
    url: 'https://www.amazon.com/Casio-SA76-mini-Sized-Tones/dp/B00416WHV4',
    largestImageUrl: '81Z5QowDQHL._SL1500_.jpg',
    categories: [
      'Musical Instruments',
      'Keyboards & MIDI',
      'Electronic Keyboards',
      'Portable Keyboards',
    ],
    endCategory: 'Portable Keyboards',
    shortName: 'Portable Keyboard',
    priceRaw: '$49.00',
    price: 49,
  },
  {
    id: 'B00442EPXI',
    title: 'Amazon.com: Mail Boss 7114 Newspaper Holder: Home Improvement',
    url: 'https://www.amazon.com/Mail-Boss-7114-Newspaper-Holder/dp/B00442EPXI',
    largestImageUrl: '81fOKxqUUrL._SL1500_.jpg',
    categories: [
      'Tools & Home Improvement',
      'Hardware',
      'Mailboxes & Accessories',
      'Newspaper Holders',
    ],
    endCategory: 'Newspaper Holders',
    shortName: 'Newspaper Holder',
    priceRaw: '$59.00',
    price: 59,
  },
  {
    id: 'B004IMYBAG',
    title:
      'Amazon.com : Hodgson Mill Organic Rye Flour, 30-Ounce (Pack of 6), Great for Baking Rye Bread Like Pumpernickel, Jewish Rye, or German Black Bread, Mix With Other Whole Grain Flours to Bulk Up Flavor and Nutrition : Wheat Flours And Meals : Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/Hodgson-Mill-30-Ounce-Pumpernickel-Nutrition/dp/B004IMYBAG',
    largestImageUrl: '71s7Hf2BR2B-L._SL1000_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Cooking & Baking',
      'Flours & Meals',
      'Wheat Flours & Meals',
    ],
    endCategory: 'Wheat Flours & Meals',
    shortName: 'Wheat Flours & Meal',
    priceRaw: '$30.85',
    price: 30.85,
  },
  {
    id: 'B004MTCEQI',
    title:
      'Amazon.com : Raffle Tickets 2000 per Roll 50/50: Orange : Office Products',
    url: 'https://www.amazon.com/Raffle-Tickets-2000-Roll-50/dp/B004MTCEQI',
    largestImageUrl: '9198pLGVHsL._SL1500_.jpg',
    categories: [
      'Office Products',
      'Office & School Supplies',
      'Labels, Indexes & Stamps',
      'Tags & Tickets',
      'Tickets',
    ],
    endCategory: 'Tickets',
    shortName: 'Ticket',
    priceRaw: '$10.05',
    price: 10.05,
  },
  {
    id: 'B005E3PUHQ',
    title:
      'Kohler K-3977-0 Wellworth Round-Front 1.6 gpf Toilet, White - Two Piece Toilets - Amazon.com',
    url:
      'https://www.amazon.com/Kohler-K-3977-0-Wellworth-Round-Front-Toilet/dp/B005E3PUHQ',
    largestImageUrl: '71JvAWTVr3L._SL1500_.jpg',
    categories: [
      'Tools & Home Improvement',
      'Kitchen & Bath Fixtures',
      'Bathroom Fixtures',
      'Toilets & Toilet Parts',
      'Toilets',
      'Two-Piece Toilets',
    ],
    endCategory: 'Two-Piece Toilets',
    shortName: 'Two-Piece Toilet',
    priceRaw: '',
    price: null,
  },
  {
    id: 'B005SF6PVK',
    title:
      'Amazon.com: Classic Brands 4.5-Inch Memory Foam Replacement Mattress for Sleeper Sofa Bed, Twin: Home & Kitchen',
    url:
      'https://www.amazon.com/Classic-Brands-4-5-Inch-Replacement-Mattress/dp/B005SF6PVK',
    largestImageUrl: '614pslnQgQL._SL1000_.jpg',
    categories: [
      'Home & Kitchen',
      'Furniture',
      'Living Room Furniture',
      'Sofas & Couches',
    ],
    endCategory: 'Sofas & Couches',
    shortName: 'Sofas & Couch',
    priceRaw: '$93.99',
    price: 93.99,
  },
  {
    id: 'B000KNZK2K',
    title:
      'Amazon.com: 250 Feet 14 Gauge Pure Copper Core eXtreme Speaker Wire, Not CCA (Copper Clad Aluminum) for Optimal Audio Performance | Stranded Core and Polarity Stripe: Home Audio & Theater',
    url:
      'https://www.amazon.com/eXtreme-Aluminum-Performance-Stranded-Polarity/dp/B000KNZK2K',
    largestImageUrl: '715qpTW0ZIL._SL1022_.jpg',
    categories: [
      'Electronics',
      'Accessories & Supplies',
      'Audio & Video Accessories',
      'Cables & Interconnects',
      'Audio Cables',
      'Speaker Cables',
    ],
    endCategory: 'Speaker Cables',
    shortName: 'Speaker Cable',
    priceRaw: '$69.95',
    price: 69.95,
  },
  {
    id: 'B00APAQSP6',
    title:
      'TaoTronics LED Desk Lamp with USB Charging Port, 4 Lighting Modes with 5 Brightness Levels, 1h Timer, Touch Control, Memory Function, Black, 14W, Official Member of Philips EnabLED Licensing Program - V Light Lighting Led Strip Desk Lamp - Amazon.com',
    url:
      'https://www.amazon.com/TaoTronics-Charging-Lighting-Brightness-Licensing/dp/B00APAQSP6',
    largestImageUrl: '41M4rSyoZDL._SL1000_.jpg',
    categories: [
      'Tools & Home Improvement',
      'Lighting & Ceiling Fans',
      'Lamps & Shades',
      'Desk Lamps',
    ],
    endCategory: 'Desk Lamps',
    shortName: 'Desk Lamp',
    priceRaw: '28.99',
    price: 28.99,
  },
  {
    id: 'B00B04BN3S',
    title:
      'Amazon.com: Cargill Skillet Frittata with Egg, Cheese and Turkey Sausage - Entree, 2.2 Ounce - 225 per case.: Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/Cargill-Skillet-Frittata-Cheese-Sausage/dp/B00B04BN3S',
    largestImageUrl: '51I8HPpmVUL._SL1000_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Dairy, Cheese & Eggs',
      'Eggs & Egg Substitutes',
      'Whole Eggs',
    ],
    endCategory: 'Whole Eggs',
    shortName: 'Whole Egg',
    priceRaw: '$210.95',
    price: 210.95,
  },
  {
    id: 'B00B04JA0G',
    title:
      'Country Crock Margarine, 5 Gram - 900 per case.: Amazon.com: Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/Country-Crock-Margarine-Gram-case/dp/B00B04JA0G',
    largestImageUrl: '61Y80Sw0TYL._SL1000_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Dairy, Cheese & Eggs',
      'Butter & Margarine',
    ],
    endCategory: 'Butter & Margarine',
    shortName: 'Butter & Margarine',
    priceRaw: '$72.95',
    price: 72.95,
  },
  {
    id: 'B00DH0Z3BG',
    title:
      'Amazon.com: TYR Special Ops 2.0 Polarized Swimming Goggle, Black: TYR: Sports & Outdoors',
    url:
      'https://www.amazon.com/TYR-Special-Polarized-Swimming-Goggle/dp/B00GSN0L3O',
    largestImageUrl: '51aYWtFhOHL._SL1000_.jpg',
    categories: [
      'Sports & Outdoors',
      'Sports & Fitness',
      'Swimming',
      'Goggles',
    ],
    endCategory: 'Goggles',
    shortName: 'Goggle',
    priceRaw: '$22.99',
    price: 22.99,
  },
  {
    id: 'B00DWGIWWM',
    title:
      'Amazon.com : 6 Inches x 6 Inches Sample Frieze Shag 32 oz Area Rug Carpet Silken Many sizes and Shapes : Kitchen & Dining',
    url:
      'https://www.amazon.com/Inches-Sample-Frieze-Carpet-Silken/dp/B00DWGIWWM',
    largestImageUrl: '71ZGRkqYtiL._SL1050_.jpg',
    categories: [
      'Home & Kitchen',
      'Home Décor',
      'Area Rugs, Runners & Pads',
      'Area Rugs',
    ],
    endCategory: 'Area Rugs',
    shortName: 'Area Rug',
    priceRaw: '5.00',
    price: 5,
  },
  {
    id: 'B00E9V4P02',
    title:
      'Amazon.com: SimpleAir Clean Flow HVAC Drain Line Treatment Tabs, 6 pk: Home Improvement',
    url:
      'https://www.amazon.com/SimpleAir-Clean-Flow-Drain-Treatment/dp/B00E9V4P02',
    largestImageUrl: '61jTJpdaf5L._SL1000_.jpg',
    categories: [
      'Health & Household',
      'Household Supplies',
      'Household Cleaning',
      'Drain Openers',
    ],
    endCategory: 'Drain Openers',
    shortName: 'Drain Opener',
    priceRaw: '$9.49',
    price: 9.49,
  },
  {
    id: 'B00FAN44FE',
    title:
      'Amazon.com | Stella Artois 6-Pack Original Glass Chalice, 33cl: Beer Glasses: Beer Glasses',
    url:
      'https://www.amazon.com/Stella-Artois-6-Pack-Original-Chalice/dp/B00FAN44FE',
    largestImageUrl: '81pIBeGhhGL._SL1500_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Dining & Entertaining',
      'Glassware & Drinkware',
      'Beer Glasses',
    ],
    endCategory: 'Beer Glasses',
    shortName: 'Beer Glass',
    priceRaw: '$47.95',
    price: 47.95,
  },
  {
    id: 'B00FFJ2LXU',
    title:
      'Amazon.com: Angel Soft 2 Ply Toilet Paper, 48 Double Bath Tissue (Pack of 4 with 12 rolls each): Health & Personal Care',
    url: 'https://www.amazon.com/Angel-Soft-Toilet-Double-Tissue/dp/B00FFJ2LXU',
    largestImageUrl: '71Ov8GvnPjL._SL1000_.jpg',
    categories: [
      'Health & Household',
      'Household Supplies',
      'Paper & Plastic',
      'Toilet Paper, Wipes & Sprays',
      'Toilet Paper',
    ],
    endCategory: 'Toilet Paper',
    shortName: 'Toilet Paper',
    priceRaw: '$24.99',
    price: 24.99,
  },
  {
    id: 'B00J08SU50',
    title:
      'Amazon.com: Augusta Sportswear Medium Length Apron Pouch, One Size, Khaki: Sports & Outdoors',
    url:
      'https://www.amazon.com/Augusta-Sportswear-Medium-Length-Apron/dp/B077L24PT2',
    largestImageUrl: '81FTJv1uh3L._SL1500_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Kitchen & Table Linens',
      'Aprons',
    ],
    endCategory: 'Aprons',
    shortName: 'Apron',
    priceRaw: '$13.36',
    price: 13.36,
  },
  {
    id: 'B00JE0LEPW',
    title:
      'Amazon.com : Gourmet Variety Sampler Gift Basket - Smoked Summer Sausages & 100% Wisconsin Cheeses - GLUTEN-FREE - Perfect Cheese and Sausage Snack!! : Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/Gourmet-Variety-Sampler-Gift-Basket/dp/B00JE0LEPW',
    largestImageUrl: '91gvT6MtM1L._SL1500_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Food & Beverage Gifts',
      'Snack Gifts',
    ],
    endCategory: 'Snack Gifts',
    shortName: 'Snack Gift',
    priceRaw: '$29.99',
    price: 29.99,
  },
  {
    id: 'B00KE8WBAU',
    title:
      'Amazon.com: Strider - 12 Sport Balance Bike, Ages 18 Months to 5 Years, Black: Sports & Outdoors',
    url:
      'https://www.amazon.com/Strider-Sport-Balance-Months-Years/dp/B00J9471SW',
    largestImageUrl: '81yOUDO0yWL._SL1500_.jpg',
    categories: [
      'Toys & Games',
      'Tricycles, Scooters & Wagons',
      'Balance Bikes',
    ],
    endCategory: 'Balance Bikes',
    shortName: 'Balance Bike',
    priceRaw: '$109.99',
    price: 109.99,
  },
  {
    id: 'B00KTZK6AA',
    title:
      'Amazon.com: 10 Pack Clear Dimmable T4 Q35/GY6.35/CL/120V GY6.35 JCD 35 Watt 35W 120 Volt Halogen Light Bulb Electric Wax Melter Plug In Warmer Aroma Tart Counter Lighting Kitchen Bathroom Mirror Fixture gy6.35: Kitchen & Dining',
    url:
      'https://www.amazon.com/Dimmable-Halogen-Electric-Lighting-Bathroom/dp/B00KTZK6AA',
    largestImageUrl: '81xx0ovubzL._SL1500_.jpg',
    categories: ['Tools & Home Improvement', 'Light Bulbs', 'Halogen Bulbs'],
    endCategory: 'Halogen Bulbs',
    shortName: 'Halogen Bulb',
    priceRaw: '$11.99',
    price: 11.99,
  },
  {
    id: 'B00M6QODH2',
    title:
      'Amazon.com: AUKEY Car Charger, Flush Fit Dual Port 24W/4.8A Output for iPhone XS/Max/XR/X/8, iPad Pro/Air 2/Mini, Samsung Galaxy Note9/Note8/S9/S9+ and More: Cell Phones & Accessories',
    url:
      'https://www.amazon.com/AUKEY-Charger-Output-iPhone-Samsung/dp/B00M6QODH2',
    largestImageUrl: '61hVeuYpIHL._SL1150_.jpg',
    categories: [
      'Cell Phones & Accessories',
      'Accessories',
      'Chargers & Power Adapters',
      'Car Chargers',
    ],
    endCategory: 'Car Chargers',
    shortName: 'Car Charger',
    priceRaw: '$10.99',
    price: 10.99,
  },
  {
    id: 'B00MWHDNT4',
    title:
      'Amazon.com : Shimano BR-T4000 Rear V-Brake, Black : Sports & Outdoors',
    url:
      'https://www.amazon.com/Shimano-Mountain-Bicycle-V-Brake-BR-T4000/dp/B00MWHDM9A',
    largestImageUrl: '61qzS5o46IL._SL1500_.jpg',
    categories: [
      'Sports & Outdoors',
      'Outdoor Recreation',
      'Cycling',
      'Parts & Components',
      'Bike Brakes & Parts',
      'Brake Parts',
    ],
    endCategory: 'Brake Parts',
    shortName: 'Brake Part',
    priceRaw: '$13.70',
    price: 13.7,
  },
  {
    id: 'B00OCEBMFM',
    title:
      'Amazon.com: OXO Good Grips Silicone Drain Protector for Pop-Up & Regular Drains: Home & Kitchen',
    url:
      'https://www.amazon.com/OXO-Silicone-Protector-Pop-Up-Regular/dp/B00OCEBMFM',
    largestImageUrl: '712Sg5SB59L._SL1500_.jpg',
    categories: [
      'Home & Kitchen',
      'Bath',
      'Bathroom Accessories',
      'Bathtub Accessories',
      'Drain Catches',
    ],
    endCategory: 'Drain Catches',
    shortName: 'Drain Catch',
    priceRaw: '$8.99',
    price: 8.99,
  },
  {
    id: 'B00OXSR486',
    title:
      'Amazon.com: Oster Extra Large Digital Countertop Convection Oven, Stainless Steel (TSSTTVDGXL-SHP): Kitchen & Dining',
    url:
      'https://www.amazon.com/Oster-Countertop-Convection-Stainless-TSSTTVDGXL-SHP/dp/B00OXSR486',
    largestImageUrl: '81lisB8vuHL._SL1500_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Small Appliances',
      'Ovens & Toasters',
      'Toaster Ovens',
    ],
    endCategory: 'Toaster Ovens',
    shortName: 'Toaster Oven',
    priceRaw: '$99.99',
    price: 99.99,
  },
  {
    id: 'B00Q8JJ23S',
    title:
      'Amazon.com: Arm & Hammer Clean Burst Liquid Laundry Detergent, 150 fl oz: Prime Pantry',
    url:
      'https://www.amazon.com/Arm-Hammer-Liquid-Laundry-Detergent/dp/B00Q8JJ23S',
    largestImageUrl: '71hB7ub0sPL._SL1500_.jpg',
    categories: [],
    endCategory: 'Food',
    shortName: 'Food',
    priceRaw: '$7.47',
    price: 7.47,
  },
  {
    id: 'B00TECQ2CU',
    title:
      'Amazon.com : MyGift Space Saving Black Metal Wire Mesh 8 Compartment Office/School Supply Desktop Organizer Caddy w/Drawer : Office Products',
    url:
      'https://www.amazon.com/MyGift-Saving-Compartment-Desktop-Organizer/dp/B00TECQ2CU',
    largestImageUrl: 'A1QXwmf5qRL._SL1500_.jpg',
    categories: [
      'Office Products',
      'Office & School Supplies',
      'Desk Accessories & Workspace Organizers',
      'Drawer Organizers',
    ],
    endCategory: 'Drawer Organizers',
    shortName: 'Drawer Organizer',
    priceRaw: '$12.99',
    price: 12.99,
  },
  {
    id: 'B00UMDFVFY',
    title:
      "Amazon.com: Citizen Women's Eco-Drive  Silhouette Crystal Watch with Date, FE1140-86L: Clothing",
    url:
      'https://www.amazon.com/Citizen-Eco-Drive-Silhouette-Crystal-FE1140-86L/dp/B00UMDFVFY',
    largestImageUrl: '915CNaUh-IL._UL1500_.jpg',
    categories: [
      'Clothing, Shoes & Jewelry',
      'Women',
      'Watches',
      'Wrist Watches',
    ],
    endCategory: 'Wrist Watches',
    shortName: 'Wrist Watch',
    priceRaw: '',
    price: null,
  },
  {
    id: 'B00WS2MJIO',
    title:
      'Amazon.com: WolVol Transport Car Carrier Truck Toy for Boys and Girls (includes 6 cars and 28 slots): Toys & Games',
    url:
      'https://www.amazon.com/WolVol-Transport-Carrier-Truck-Girls/dp/B00WS2MJIO',
    largestImageUrl: '71uOb39G7sL._SL1500_.jpg',
    categories: [
      'Toys & Games',
      'Toy Remote Control & Play Vehicles',
      'Play Vehicles',
    ],
    endCategory: 'Play Vehicles',
    shortName: 'Play Vehicle',
    priceRaw: '$28.94',
    price: 28.94,
  },
  {
    id: 'B00WTHIVHQ',
    title: 'Amazon.com: AmazonBasics Hanging Toiletry Kit, Black',
    url:
      'https://www.amazon.com/AmazonBasics-Hanging-Toiletry-Kit-Black/dp/B00WTHIVHQ',
    largestImageUrl: '91NStQCWcHL._SL1500_.jpg',
    categories: [
      'Beauty & Personal Care',
      'Tools & Accessories',
      'Bags & Cases',
      'Toiletry Bags',
    ],
    endCategory: 'Toiletry Bags',
    shortName: 'Toiletry Bag',
    priceRaw: '$11.49',
    price: 11.49,
  },
  {
    id: 'B00WWBCSG4',
    title:
      'Amazon.com: PNY Elite Performance 64GB Flash Memory High Speed SDXC Class 10 UHS-I (P-SDX64U395-GE): Computers & Accessories',
    url:
      'https://www.amazon.com/PNY-Elite-Performance-Memory-P-SDX64U395-GE/dp/B00WWBCSG4',
    largestImageUrl: '81IRZaRkLlL._SL1500_.jpg',
    categories: [
      'Electronics',
      'Computers & Accessories',
      'Computer Accessories & Peripherals',
      'Memory Cards',
      'SD Cards',
    ],
    endCategory: 'SD Cards',
    shortName: 'SD Card',
    priceRaw: '21.99',
    price: 21.99,
  },
  {
    id: 'B00XQMAC1G',
    title:
      'Amazon.com : Fiber Yum Non-GMO, Corn-Free, Pre-Biotic Fiber IMO Syrup Sweetener - 2.5 Pound : Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/Fiber-Non-GMO-Corn-Free-Pre-Biotic-Sweetener/dp/B00XQMAC1G',
    largestImageUrl: '81t7l8Ow-UL._SL1500_.jpg',
    categories: ['Grocery & Gourmet Food', 'Cooking & Baking'],
    endCategory: 'Cooking & Baking',
    shortName: 'Cooking & Baking',
    priceRaw: '$27.38',
    price: 27.38,
  },
  {
    id: 'B014S7JPCO',
    title:
      'Bare Decor EZ-Floor Interlocking Flooring Tiles in Solid Teak Wood Oiled Finish (Set of 10), Long 9 Slat - - Amazon.com',
    url:
      'https://www.amazon.com/Bare-Decor-EZ-Floor-Interlocking-Flooring/dp/B014S7JPCO',
    largestImageUrl: '91odBF0vPOL._SL1500_.jpg',
    categories: [
      'Tools & Home Improvement',
      'Building Supplies',
      'Building Materials',
      'Decking & Fencing',
      'Materials',
      'Wood Composite Decking',
    ],
    endCategory: 'Wood Composite Decking',
    shortName: 'Wood Composite Decking',
    priceRaw: '$79.99',
    price: 79.99,
  },
  {
    id: 'B0154YYJGW',
    title:
      'Amazon.com: BIC SoftFeel Retractable Pen, 1.0 mm Medium Tip, Blue, Pack of 36: Office Products',
    url:
      'https://www.amazon.com/d/Ballpoint-Pens/BIC-SoftFeel-Retractable-Medium-Blue/B0154YYJGW',
    largestImageUrl: '81hUCHXKAlL._SL1500_.jpg',
    categories: [
      'Office Products',
      'Office & School Supplies',
      'Writing & Correction Supplies',
      'Pens & Refills',
      'Ballpoint Pens',
    ],
    endCategory: 'Ballpoint Pens',
    shortName: 'Ballpoint Pen',
    priceRaw: '$25.65',
    price: 25.65,
  },
  {
    id: 'B016EYSNEK',
    title:
      'Amazon.com: Zwipes Professional Premium Microfiber Cleaning Cloth Towels, 16x16 inch, 12-Pack, Assorted Colors: Home Improvement',
    url:
      'https://www.amazon.com/Zwipes-Professional-Microfiber-Cleaning-Assorted/dp/B016EYSNEK',
    largestImageUrl: '81rDXLUdDNL._SL1500_.jpg',
    categories: [
      'Automotive',
      'Car Care',
      'Tools & Equipment',
      'Cloths & Towels',
      'Chamois',
    ],
    endCategory: 'Chamois',
    shortName: 'Chamois',
    priceRaw: '$16.72',
    price: 16.72,
  },
  {
    id: 'B016I5TM2M',
    title:
      'Amazon.com: Prepara Non-drip Oil Cruet, glass base: Kitchen & Dining',
    url:
      'https://www.amazon.com/Prepara-Non-drip-Cruet-glass-base/dp/B016I5TM2M',
    largestImageUrl: '61k0KyBcXzL._SL1500_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Kitchen Utensils & Gadgets',
      'Oil Sprayers & Dispensers',
      'Cruets',
    ],
    endCategory: 'Cruets',
    shortName: 'Cruet',
    priceRaw: '$10.95',
    price: 10.95,
  },
  {
    id: 'B01C8PTKM8',
    title:
      'Stalwart 16 Ounce Claw Hammer - Basic Hand Tool for DIY and Woodworking with Natural Wood Anti-Vibration Handle and Drop Forged Steel Head - - Amazon.com',
    url:
      'https://www.amazon.com/Stalwart-75-HT3000-Natural-Hardwood-Hammer/dp/B01C8PTKM8',
    largestImageUrl: '71tTWyypTKL._SL1500_.jpg',
    categories: [
      'Tools & Home Improvement',
      'Power & Hand Tools',
      'Hand Tools',
      'Hammers',
      'Claw Hammers',
    ],
    endCategory: 'Claw Hammers',
    shortName: 'Claw Hammer',
    priceRaw: '$6.92',
    price: 6.92,
  },
  {
    id: 'B01G8BJIAC',
    title:
      'Amazon.com : Mentos Sugar-Free Chewing Gum, Bubble Fresh Cotton Candy, 45 Piece Bottle (Pack of 4) : Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/Mentos-Sugar-Free-Chewing-Bubble-Cotton/dp/B01G8BJIAC',
    largestImageUrl: '91fp2B2BQ84xL._SL1500_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Candy & Chocolate',
      'Chewing & Bubble Gum',
    ],
    endCategory: 'Chewing & Bubble Gum',
    shortName: 'Chewing & Bubble Gum',
    priceRaw: '$12.49',
    price: 12.49,
  },
  {
    id: 'B01H7RIFG4',
    title:
      'Amazon.com: iXtreme Baby Boys Expedition Puffer Winter Snowsuit Pram Bunting: Clothing',
    url:
      'https://www.amazon.com/iXtreme-Expedition-Puffer-Snowsuit-Bunting/dp/B01H7RIFG4',
    largestImageUrl: '71-yrJsUaEL._UL1500_.jpg',
    categories: [
      'Clothing, Shoes & Jewelry',
      'Baby',
      'Baby Boys',
      'Clothing',
      'Jackets & Coats',
      'Snow Wear',
    ],
    endCategory: 'Snow Wear',
    shortName: 'Snow Wear',
    priceRaw: '$29.99',
    price: 29.99,
  },
  {
    id: 'B01HHVRYHG',
    title:
      "Amazon.com: Keebler Club Crackers, Snack Stacks, Original, Grab 'N' Go, Family Size, 18.8 oz box: Prime Pantry",
    url:
      'https://www.amazon.com/Keebler-Club-Crackers-Stacks-Original/dp/B01HHVRYHG',
    largestImageUrl: '81ksKaLYPzL._SL1500_.jpg',
    categories: [],
    endCategory: 'Food',
    shortName: 'Food',
    priceRaw: '$3.82',
    price: 3.82,
  },
  {
    id: 'B01HONVHZ2',
    title:
      'Amazon.com: Bernhard Products Black Wall Clock, Silent Non Ticking - 10 Inch Quality Quartz Battery Operated Round Easy to Read Home/Office/School Clock: Kitchen & Dining',
    url:
      'https://www.amazon.com/Bernhard-Products-Black-Silent-Ticking/dp/B01HONVHZ2',
    largestImageUrl: '81os6R4wnNL._SL1500_.jpg',
    categories: ['Home & Kitchen', 'Home Décor', 'Clocks', 'Wall Clocks'],
    endCategory: 'Wall Clocks',
    shortName: 'Wall Clock',
    priceRaw: '$9.97',
    price: 9.97,
  },
  {
    id: 'B01I416YEC',
    title:
      "EZARC Tungsten Carbide Teeth Hole Saw (Hole Cutter) Heavy Duty for Stainless Steel 2-1/8'' 54mm - - Amazon.com",
    url:
      'https://www.amazon.com/EZARC-Tungsten-Carbide-Cutter-Stainless/dp/B01I416YEC',
    largestImageUrl: '51TTugZkqmL._SL1024_.jpg',
    categories: [
      'Tools & Home Improvement',
      'Power & Hand Tools',
      'Power Tool Parts & Accessories',
      'Power Drill Parts & Accessories',
      'Hole Saws & Accessories',
    ],
    endCategory: 'Hole Saws & Accessories',
    shortName: 'Hole Saws & Accessory',
    priceRaw: '$46.74',
    price: 46.74,
  },
  {
    id: 'B01IFCJ6WM',
    title:
      'Amazon.com: Plastic Portion Cups with Lids 2 oz. 150 Pack Condiment Sauce Snack Souffle Dressing, Jello Shot Cup Containers, BPA free - by DuraHome: Kitchen & Dining',
    url:
      'https://www.amazon.com/Plastic-Portion-Condiment-Dressing-Containers/dp/B01IFCJ6WM',
    largestImageUrl: '61sJ-9qj8aL._SL1281_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Storage & Organization',
      'Food Storage',
      'Food Storage & Organization Sets',
    ],
    endCategory: 'Food Storage & Organization Sets',
    shortName: 'Food Storage & Organization Set',
    priceRaw: '$12.85',
    price: 12.85,
  },
  {
    id: 'B01JRXGCIE',
    title:
      'Amazon.com: eBoot Airplane Airline Flight Adapters for Headphones (3 Pack, Golden Plated): Home Audio & Theater',
    url:
      'https://www.amazon.com/eBoot-Airplane-Airline-Adapters-Headphones/dp/B01JRXGCIE',
    largestImageUrl: '71Q6gzUE5WL._SL1500_.jpg',
    categories: [
      'Electronics',
      'Accessories & Supplies',
      'Audio & Video Accessories',
      'Headphone Accessories',
      'Adapters',
    ],
    endCategory: 'Adapters',
    shortName: 'Adapter',
    priceRaw: '$6.47',
    price: 6.47,
  },
  {
    id: 'B01KBEOM2G',
    title:
      'Amazon.com: AmazonBasics Heavy-Duty, Full Motion Articulating TV Wall Mount for 32-inch to 80-inch LED, LCD, Flat Screen TVs: Electronics',
    url:
      'https://www.amazon.com/AmazonBasics-Heavy-Duty-Articulating-32-inch-80-inch/dp/B01KBEOM2G',
    largestImageUrl: '71I8uq2Be3TL._SL1500_.jpg',
    categories: [
      'Electronics',
      'Accessories & Supplies',
      'Audio & Video Accessories',
      'TV Accessories & Parts',
      'TV Ceiling & Wall Mounts',
    ],
    endCategory: 'TV Ceiling & Wall Mounts',
    shortName: 'TV Ceiling & Wall Mount',
    priceRaw: '$40.00',
    price: 40,
  },
  {
    id: 'B01KT1V7KG',
    title:
      'Amazon.com : Trademark Gameroom Guinness 16" Handmade Tiffany Style Lamp : Sports & Outdoors',
    url:
      'https://www.amazon.com/Trademark-Gameroom-Guinness-Handmade-Tiffany/dp/B01KT1V7KG',
    largestImageUrl: '812xxm2dGTL._SL1500_.jpg',
    categories: [
      'Sports & Outdoors',
      'Fan Shop',
      'Home & Kitchen',
      'Furniture',
      'Billiard Lighting',
    ],
    endCategory: 'Billiard Lighting',
    shortName: 'Billiard Lighting',
    priceRaw: '161.37',
    price: 161.37,
  },
  {
    id: 'B01L84Y3XG',
    title:
      'Amazon.com | Gibson Home 102261.16RM Soho Lounge Matte 16 Piece Dinnerware Set, Black: Dinnerware Sets',
    url:
      'https://www.amazon.com/Gibson-Home-102261-16RM-Lounge-Dinnerware/dp/B01L84Y3XG',
    largestImageUrl: '81LhwHa34oL._SL1500_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Dining & Entertaining',
      'Dinnerware',
      'Dinnerware Sets',
    ],
    endCategory: 'Dinnerware Sets',
    shortName: 'Dinnerware Set',
    priceRaw: '$34.86',
    price: 34.86,
  },
  {
    id: 'B01M1E4BPE',
    title:
      'Amazon.com: Discovery Toys Dino Works Take-A-Part T-Rex: Toys & Games',
    url: 'https://www.amazon.com/Discovery-Toys-Works-Take-Part/dp/B01M1E4BPE',
    largestImageUrl: '81sYROAaJML._SL1500_.jpg',
    categories: ['Toys & Games', 'Building Toys', 'Building Sets'],
    endCategory: 'Building Sets',
    shortName: 'Building Set',
    priceRaw: '$18.99',
    price: 18.99,
  },
  {
    id: 'B01MS024I1',
    title:
      'Chicken Whole Free Range (Count 1) - 3.4 Lbs.: Amazon.com: Grocery & Gourmet Food',
    url: 'https://www.amazon.com/Chicken-Whole-Free-Range-Count/dp/B01MS024I1',
    largestImageUrl: '71lmGRv1YxL._SL1500_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Meat & Seafood',
      'Chicken',
      'Whole Chickens',
    ],
    endCategory: 'Whole Chickens',
    shortName: 'Whole Chicken',
    priceRaw: '$68.95',
    price: 68.95,
  },
  {
    id: 'B01NCECKQ4',
    title:
      'Amazon.com : Tommy Bahama The Big Kahuna Beach Chair Blue Print : Sports & Outdoors',
    url: 'https://www.amazon.com/Tommy-Bahama-Kahuna-Beach-Chair/dp/B06Y24K8B3',
    largestImageUrl: '81lsqK0iBkL._SL1500_.jpg',
    categories: [
      'Sports & Outdoors',
      'Outdoor Recreation',
      'Camping & Hiking',
      'Camping Furniture',
      'Chairs',
    ],
    endCategory: 'Chairs',
    shortName: 'Chair',
    priceRaw: '$79.99',
    price: 79.99,
  },
  {
    id: 'B06WLJDLQC',
    title:
      'Amazon.com: Baby Dove Fragrance FreeLotion, Sensitive Moisture, 20 oz: Beauty',
    url:
      'https://www.amazon.com/Baby-Fragrance-FreeLotion-Sensitive-Moisture/dp/B06WLJDLQC',
    largestImageUrl: '71uqsFqaEeL._SL1500_.jpg',
    categories: ['Baby Products', 'Baby Care', 'Grooming', 'Skin Care'],
    endCategory: 'Skin Care',
    shortName: 'Skin Care',
    priceRaw: '$6.58',
    price: 6.58,
  },
  {
    id: 'B06WVN23N8',
    title:
      'Amazon.com : Saddle Barn Tack Mutton Bustin Chap Vest Combo Pink : Sports & Outdoors',
    url: 'https://www.amazon.com/Saddle-Barn-Tack-Mutton-Bustin/dp/B06WVN23N8',
    largestImageUrl: '714-6HWcEdL._SL1000_.jpg',
    categories: [
      'Sports & Outdoors',
      'Sports & Fitness',
      'Other Sports',
      'Equestrian Sports',
      'Protective Gear',
    ],
    endCategory: 'Protective Gear',
    shortName: 'Protective Gear',
    priceRaw: '149.99',
    price: 149.99,
  },
  {
    id: 'B06XWF3P1Z',
    title:
      'Amazon.com: 6 Pack 40 Watts Microwave Replacement Bulb for Most Ge and Whirlpool Oven, 40T8 E17 Base Appliance Light Bulb MOL 2.5 ": Home Improvement',
    url:
      'https://www.amazon.com/Watts-Microwave-Replacement-Whirlpool-Appliance/dp/B06XWF3P1Z',
    largestImageUrl: '71IZmdBz6rL._SL1500_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Small Appliance Parts & Accessories',
      'Microwave Oven Parts & Accessories',
      'Microwave Oven Replacement Parts',
    ],
    endCategory: 'Microwave Oven Replacement Parts',
    shortName: 'Microwave Oven Replacement Part',
    priceRaw: '$8.98',
    price: 8.98,
  },
  {
    id: 'B06Y1F55J7',
    title:
      "Amazon.com: Camco 39659 Super Kit RV Sewer Hose Kit - 20': Automotive",
    url: 'https://www.amazon.com/Camco-39659-Super-Sewer-Hose/dp/B06Y1F55J7',
    largestImageUrl: '81mc2BbdTX6L._SL1500_.jpg',
    categories: [
      'Automotive',
      'RV Parts & Accessories',
      'Waste Water & Sanitation',
      'Sewer Hose Carriers & Fittings',
    ],
    endCategory: 'Sewer Hose Carriers & Fittings',
    shortName: 'Sewer Hose Carriers & Fitting',
    priceRaw: '$34.25',
    price: 34.25,
  },
  {
    id: 'B071G6B1G8',
    title:
      'Amazon.com: Duro Heavy Duty Kraft Brown Paper Barrel Sack Bag, 57 Lbs Basis Weight, 12 x 7 x 17, 100 Ct/Pack: Home & Kitchen',
    url: 'https://www.amazon.com/Duro-Heavy-Kraft-Barrel-Weight/dp/B071G6B1G8',
    largestImageUrl: '517kAW7cwRL._SL1000_.jpg',
    categories: [
      'Home & Kitchen',
      'Storage & Organization',
      'Baskets, Bins & Containers',
    ],
    endCategory: 'Baskets, Bins & Containers',
    shortName: 'Baskets, Bins & Container',
    priceRaw: '$22.97',
    price: 22.97,
  },
  {
    id: 'B00005LF01',
    title:
      'DEWALT D180002 Standard Electricians Bi-Metal Hole Saw Kit - Hole Saw Sets - Amazon.com',
    url:
      'https://www.amazon.com/DEWALT-D180002-Standard-Electricians-Bi-Metal/dp/B00005LF01',
    largestImageUrl: '717Q0lEcnCL._SL1500_.jpg',
    categories: [
      'Tools & Home Improvement',
      'Power & Hand Tools',
      'Power Tool Parts & Accessories',
      'Power Drill Parts & Accessories',
      'Hole Saws & Accessories',
      'Hole Saw Sets',
    ],
    endCategory: 'Hole Saw Sets',
    shortName: 'Hole Saw Set',
    priceRaw: '44.99',
    price: 44.99,
  },
  {
    id: 'B071G77T5V',
    title:
      'Amazon.com : Keter Oakland 7.5 x 7 Outdoor Duotech Storage Shed, Paintable with Window and Skylight, Brown : Garden & Outdoor',
    url:
      'https://www.amazon.com/Keter-Oakland-Outdoor-Paintable-Skylight/dp/B071G77T5V',
    largestImageUrl: '71dN-xU9SNL._SL1500_.jpg',
    categories: ['Patio, Lawn & Garden', 'Outdoor Storage', 'Storage Sheds'],
    endCategory: 'Storage Sheds',
    shortName: 'Storage Shed',
    priceRaw: '1109.99',
    price: 1109.99,
  },
  {
    id: 'B071L8S6WM',
    title:
      "Ruxia Women's Hipster Panties Seamless Low-Rise Cheekini Panty Soft Stretch Bikini Underwear (Multi Colors, Pack of 5) at Amazon Women’s Clothing store:",
    url:
      'https://www.amazon.com/Ruxia-Seamless-Low-Rise-Cheekini-Underwear/dp/B071L8S6WM',
    largestImageUrl: '81NSkigjfkL._UL1500_.jpg',
    categories: [
      'Clothing, Shoes & Jewelry',
      'Women',
      'Clothing',
      'Lingerie, Sleep & Lounge',
      'Lingerie',
      'Panties',
      'Bikinis',
    ],
    endCategory: 'Bikinis',
    shortName: 'Bikini',
    priceRaw: '$15.59 - $18.59',
    price: 18.59,
  },
  {
    id: 'B071LSL3SP',
    title:
      'Amazon.com: Vremi 8 Piece Ceramic Nonstick Cookware Set - Induction Stovetop Compatible Dishwasher Safe Non Stick Pots and Frying Pans with Lids - Dutch Oven Pot Fry Pan Sets for Serving - PTFE PFOA Free - Yellow: Kitchen & Dining',
    url:
      'https://www.amazon.com/d/Kitchen-Cookware-Sets/Vremi-Piece-Ceramic-Nonstick-Cookware/B071LSL3SP',
    largestImageUrl: '71zHtQlEr6L._SL1500_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Cookware',
      'Cookware Sets',
    ],
    endCategory: 'Cookware Sets',
    shortName: 'Cookware Set',
    priceRaw: '$112.95',
    price: 112.95,
  },
  {
    id: 'B071PCGZTB',
    title:
      'Amazon.com: DarkBlue The Newest Generation Ultra Outdoor Portable Wireless Bluetooth Speakers,with Amazing Enhanced Super Bass,10W+ Louder Volume, Hands Free, FM Radio, TF Card, IPX6 Waterproof (Army Green): Home Audio & Theater',
    url:
      'https://www.amazon.com/DarkBlue-Generation-Portable-Bluetooth-Waterproof/dp/B071PCGZTB',
    largestImageUrl: '71aB1eIyIEL._SL1001_.jpg',
    categories: [
      'Electronics',
      'Portable Audio & Video',
      'Portable Speakers & Docks',
      'Portable Bluetooth Speakers',
    ],
    endCategory: 'Portable Bluetooth Speakers',
    shortName: 'Portable Bluetooth Speaker',
    priceRaw: '$34.99',
    price: 34.99,
  },
  {
    id: 'B071XY2J2D',
    title:
      'Nebraska Star Beef Angus Beef Gift Package, Premium Ribeye: Amazon.com: Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/Nebraska-Star-Beef-Package-Premium/dp/B071XY2J2D',
    largestImageUrl: '71eObKo0TDL._SL1000_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Meat & Seafood',
      'Beef',
      'Steaks',
      'Ribeye',
    ],
    endCategory: 'Ribeye',
    shortName: 'Ribeye',
    priceRaw: '$265.95',
    price: 265.95,
  },
  {
    id: 'B071Z2T6NK',
    title:
      'Amazon.com : Barilla Fully Cooked READY PASTA, VARIETY 8 Pack: 2 Pouches each of ROTINI, PENNE, ELBOWS, GEMELLI + FREE pack of silver plastic utensils! (8.5 oz each pouch) NEW FOR 2017! : Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/Barilla-Fully-Cooked-READY-VARIETY/dp/B071Z2T6NK',
    largestImageUrl: '91YcGEi9Y-L._SL1500_.jpg',
    categories: ['Grocery & Gourmet Food', 'Pasta & Noodles', 'Pasta', 'Penne'],
    endCategory: 'Penne',
    shortName: 'Penne',
    price: null,
  },
  {
    id: 'B072L35RZC',
    title:
      "Janmid Men's Linen Casual Classic Fit Short at Amazon Men’s Clothing store:",
    url:
      'https://www.amazon.com/Janmid-Linen-Casual-Classic-Short/dp/B072L35RZC',
    largestImageUrl: '61DO2B30bNkL._UL1000_.jpg',
    categories: [
      'Clothing, Shoes & Jewelry',
      'Men',
      'Clothing',
      'Shorts',
      'Flat Front',
    ],
    endCategory: 'Flat Front',
    shortName: 'Flat Front',
    priceRaw: '$11.99 - $16.99',
    price: 16.99,
  },
  {
    id: 'B073ZLSMFT',
    title:
      'Monoprice Select Mini 3D Printer V2 - Black With Heated (120 x 120 x 120 mm) Build Plate, Fully Assembled + Free Sample PLA Filament And MicroSD Card Preloaded With Printable 3D Models: Amazon.com: Industrial & Scientific',
    url:
      'https://www.amazon.com/Monoprice-Assembled-Filament-Preloaded-Printable/dp/B07515FG7P',
    largestImageUrl: '61Kll-cViML._SL1200_.jpg',
    categories: [
      'Industrial & Scientific',
      'Additive Manufacturing Products',
      '3D Printers',
    ],
    endCategory: '3D Printers',
    shortName: '3D Printer',
    priceRaw: '$189.99',
    price: 189.99,
  },
  {
    id: 'B0743BZLW4',
    title:
      "Men's Dress Floral Suit Notched Lapel Slim Fit Stylish Blazer Dress Suit at Amazon Men’s Clothing store:",
    url:
      'https://www.amazon.com/Dress-Floral-Notched-Stylish-Blazer-x/dp/B0743BZLW4',
    largestImageUrl: '716wlAmVpBL._UL1200_.jpg',
    categories: [
      'Clothing, Shoes & Jewelry',
      'Men',
      'Clothing',
      'Suits & Sport Coats',
      'Sport Coats & Blazers',
    ],
    endCategory: 'Sport Coats & Blazers',
    shortName: 'Sport Coats & Blazer',
    priceRaw: '$65.99 - $72.99',
    price: 72.99,
  },
  {
    id: 'B074CPTPWT',
    title:
      'Amazon.com: Winegard PL-7000 Dish Playmaker HD Portable Satellite Antenna (RV Portable Satellite Dish, Tailgating Portable Satellite Antenna) - White: Automotive',
    url:
      'https://www.amazon.com/Winegard-PL-7000-Playmaker-Satellite-Tailgating/dp/B074CPTPWT',
    largestImageUrl: '51HzrHIFrLL._SL1000_.jpg',
    categories: ['Automotive', 'RV Parts & Accessories', 'Electronics'],
    endCategory: 'Electronics',
    shortName: 'Electronic',
    priceRaw: '$248.99',
    price: 248.99,
  },
  {
    id: 'B074J3LBXT',
    title:
      "Amazon.com : UNCLE BEN'S Ready Rice: Jasmine (12pk) : Grocery & Gourmet Food",
    url: 'https://www.amazon.com/UNCLE-BENS-Ready-Rice-Jasmine/dp/B074J3LBXT',
    largestImageUrl: '81ErAPylTbL._SL1500_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Canned, Jarred & Packaged Foods',
      'Packaged Meals & Side Dishes',
      'Rice Dishes',
      'Seasoned Rice',
    ],
    endCategory: 'Seasoned Rice',
    shortName: 'Seasoned Rice',
    price: null,
  },
  {
    id: 'B0753QRL18',
    title:
      'AmazonBasics 30 Gallon Large Trash Bag with Draw Strings, 1.2 mil, 120-Count: Amazon.com: Industrial & Scientific',
    url:
      'https://www.amazon.com/AmazonBasics-Gallon-Large-Strings-120-Count/dp/B0753QRL18',
    largestImageUrl: '81M5p8HfOdL._SL1500_.jpg',
    categories: [
      'Industrial & Scientific',
      'Janitorial & Sanitation Supplies',
      'Waste Receptacles & Liners',
      'Trash Bags & Liners',
      'Can Liners',
    ],
    endCategory: 'Can Liners',
    shortName: 'Can Liner',
    priceRaw: '$25.99',
    price: 25.99,
  },
  {
    id: 'B0756G8CW6',
    title:
      '3 in 1 Repair Stick White M319-3012 Mohawk Finishing Products - - Amazon.com',
    url:
      'https://www.amazon.com/Repair-Stick-White-M319-3012-Finishing/dp/B0756G8CW6',
    largestImageUrl: '41mEo97sJWL._SL1000_.jpg',
    categories: [
      'Tools & Home Improvement',
      'Hardware',
      'Adhesives & Sealers',
      'Wood Filler',
    ],
    endCategory: 'Wood Filler',
    shortName: 'Wood Filler',
    priceRaw: '$11.75',
    price: 11.75,
  },
  {
    id: 'B075PL2GDD',
    title: 'Amazon.com - Bissell Zing Canister, 2156A Bagless Vacuum, Green -',
    url:
      'https://www.amazon.com/Bissell-Canister-2156A-Bagless-Vacuum/dp/B075PL2GDD',
    largestImageUrl: '71hQZ7tvQ8L._SL1500_.jpg',
    categories: [
      'Home & Kitchen',
      'Vacuums & Floor Care',
      'Vacuums',
      'Canister Vacuums',
    ],
    endCategory: 'Canister Vacuums',
    shortName: 'Canister Vacuum',
    priceRaw: '$49.99',
    price: 49.99,
  },
  {
    id: 'B075VFWSPD',
    title:
      'Amazon.com : Jolt Cola Carbonated Energy Drink Original Recipe (Real Sugar) 16 Ounce, 4 Count : Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/Jolt-Cola-Carbonated-Energy-Original/dp/B075VFWSPD',
    largestImageUrl: '71N4iZkiQML._SL1000_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Beverages',
      'Bottled Beverages, Water & Drink Mixes',
      'Energy Drinks',
    ],
    endCategory: 'Energy Drinks',
    shortName: 'Energy Drink',
    price: null,
  },
  {
    id: 'B0763ZK56Q',
    title:
      'Amazon.com: Elite Cuisine ECT-4829 Long Cool Touch Toaster with Extra Wide 1.5" Slots for Bagels and Specialty Breads, 4 Slices, White: Kitchen & Dining',
    url:
      'https://www.amazon.com/Elite-Cuisine-ECT-4829-Toaster-Specialty/dp/B0763ZK56Q',
    largestImageUrl: '71YsufeLY3L._SL1500_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Small Appliances',
      'Ovens & Toasters',
      'Toasters',
    ],
    endCategory: 'Toasters',
    shortName: 'Toaster',
    priceRaw: '$29.64',
    price: 29.64,
  },
  {
    id: 'B076CNN1Z8',
    title:
      "Amazon.com: Kellogg's Raisin Bran, Breakfast Cereal, Original, Excellent Source of Fiber, 76.5 oz Box (2 Bags): Prime Pantry",
    url:
      'https://www.amazon.com/Kelloggs-Raisin-Breakfast-Original-Excellent/dp/B076CNN1Z8',
    largestImageUrl: '91T0fbca3gL._SL1500_.jpg',
    categories: [],
    endCategory: 'Food',
    shortName: 'Food',
    priceRaw: '$7.98',
    price: 7.98,
  },
  {
    id: 'B076CS7YFV',
    title:
      'Berkshire Bone In 12 oz.Tomahawk Pork Chops (14 - Count): Amazon.com: Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/Berkshire-Bone-oz-Tomahawk-Pork-Chops/dp/B076CS7YFV',
    largestImageUrl: '810Icbma0TL._SL1500_.jpg',
    categories: ['Grocery & Gourmet Food', 'Meat & Seafood', 'Pork', 'Chops'],
    endCategory: 'Chops',
    shortName: 'Chop',
    price: null,
  },
  {
    id: 'B076QB2P7N',
    title:
      'Amazon.com : UNHO Wooden Flower Stands Plant Display Stand Wood Pot Shelf Storage Rack Outdoor Indoor 6 Pots Holder 96x95x25Cm : Garden & Outdoor',
    url:
      'https://www.amazon.com/Wooden-Display-Storage-Outdoor-96x95x25Cm/dp/B076QB2P7N',
    largestImageUrl: '61x-j6ZjS4L._SL1000_.jpg',
    categories: [
      'Patio, Lawn & Garden',
      'Gardening & Lawn Care',
      'Pots, Planters & Container Accessories',
      'Plant Container Accessories',
      'Stands',
    ],
    endCategory: 'Stands',
    shortName: 'Stand',
    priceRaw: '49.79',
    price: 49.79,
  },
  {
    id: 'B076ZSRVFQ',
    title:
      'Amazon.com: AmazonBasics Desktop Mini Condenser Microphone - Silver: Musical Instruments',
    url:
      'https://www.amazon.com/AmazonBasics-Desktop-Mini-Condenser-Microphone/dp/B076ZSRVFQ',
    largestImageUrl: '71-fuAwU39L._SL1500_.jpg',
    categories: [
      'Musical Instruments',
      'Microphones & Accessories',
      'Microphones',
      'Condenser Microphones',
      'Multipurpose',
    ],
    endCategory: 'Multipurpose',
    shortName: 'Multipurpose',
    priceRaw: '$42.99',
    price: 42.99,
  },
  {
    id: 'B0776NXP5Z',
    title:
      'Amazon.com : Jssmst Small Cash Box with Combination Lock - Durable Metal Cash Box with Money Tray Red, 7.87 x 6.3 x 3.35 inches, CB0703M : Office Products',
    url:
      'https://www.amazon.com/Jssmst-Small-Cash-Combination-Lock/dp/B0776NXP5Z',
    largestImageUrl: '61tw7v3MSwL._SL1200_.jpg',
    categories: [
      'Office Products',
      'Office & School Supplies',
      'Forms, Recordkeeping & Money Handling',
      'Cash & Check Boxes',
      'Cash Boxes',
    ],
    endCategory: 'Cash Boxes',
    shortName: 'Cash Box',
    priceRaw: '14.50',
    price: 14.5,
  },
  {
    id: 'B077GQYH6J',
    title:
      'Amazon.com: Costzon Kids Sofa, Toddler Gingham Roundy Armrest Chair Couch Girls & Boys Bedroom Living Room, Children Furniture (Pink): Kitchen & Dining',
    url:
      'https://www.amazon.com/Costzon-Toddler-Gingham-Children-Furniture/dp/B077GQYH6J',
    largestImageUrl: '61DxJVknvfL._SL1200_.jpg',
    categories: ['Home & Kitchen', 'Furniture', "Kids' Furniture", 'Sofas'],
    endCategory: 'Sofas',
    shortName: 'Sofa',
    priceRaw: '59.99',
    price: 59.99,
  },
  {
    id: 'B077GYP81Q',
    title:
      'Amazon.com: Thank You Bags pk. of 1000-11 ½” x 6" x 21" - Thickness .48mil HDPE- Standard Supermarket Size: Arts, Crafts & Sewing',
    url: 'https://www.amazon.com/Thank-You-Bags-pk-1000-11/dp/B077GYP81Q',
    largestImageUrl: '71zknyFxp2L._SL1458_.jpg',
    categories: [
      'Industrial & Scientific',
      'Retail Store Fixtures & Equipment',
      'Retail Bags & Boxes',
      'Shopping & Merchandise Bags',
    ],
    endCategory: 'Shopping & Merchandise Bags',
    shortName: 'Shopping & Merchandise Bag',
    priceRaw: '',
    price: null,
  },
  {
    id: 'B077ZB2557',
    title:
      'Amazon.com : (6 PACK- GRAPE) White House Organic Apple Cider Vinegar GRAPE Tonic : Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/PACK-White-House-Organic-Vinegar/dp/B077ZB2557',
    largestImageUrl: '719WEeGHIQL._SL1280_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Beverages',
      'Bottled Beverages, Water & Drink Mixes',
      'Juices',
      'Fruit Juice',
    ],
    endCategory: 'Fruit Juice',
    shortName: 'Fruit Juice',
    priceRaw: '$12.99',
    price: 12.99,
  },
  {
    id: 'B078N6SD7N',
    title:
      'Amazon.com: SunF A033 ATV/UTV Tires -- 25x11-12 -- 6 Ply | Pair of 2 | All-Terrain Off-Road: Automotive',
    url:
      'https://www.amazon.com/SunF-Tires-25x11-12-All-Terrain-Off-Road-x/dp/B078N6SD7N',
    largestImageUrl: '91XoutDi7ZL._SL1500_.jpg',
    categories: [
      'Automotive',
      'Motorcycle & Powersports',
      'Parts',
      'Wheels & Tires',
      'Tires & Accessories',
      'Tires & Inner Tubes',
      'ATV & UTV',
      'Trail',
    ],
    endCategory: 'Trail',
    shortName: 'Trail',
    priceRaw: '$171.98',
    price: 171.98,
  },
  {
    id: 'B078RVYM9P',
    title:
      'Amazon.com: [100 Pack] 8 oz. White Paper Hot Cups, Coffee Cups: Kitchen & Dining',
    url: 'https://www.amazon.com/Pack-White-Paper-Cups-Coffee/dp/B078RVYM9P',
    largestImageUrl: '510S8QHDrXL._SL1191_.jpg',
    categories: [
      'Health & Household',
      'Household Supplies',
      'Paper & Plastic',
      'Disposable Drinkware',
      'Cups',
    ],
    endCategory: 'Cups',
    shortName: 'Cup',
    priceRaw: '$9.99',
    price: 9.99,
  },
  {
    id: 'B0798B2L5H',
    title:
      'Amazon.com: TCL 65S517 65-Inch 4K Ultra HD Roku Smart LED TV (2018 Model): Televisions & Video',
    url: 'https://www.amazon.com/TCL-65S517-65-Inch-Ultra-Smart/dp/B0798B2L5H',
    largestImageUrl: '91zdkWqyJvL._SL1500_.jpg',
    categories: [
      'Electronics',
      'Television & Video',
      'Televisions',
      'LED & LCD TVs',
    ],
    endCategory: 'LED & LCD TVs',
    shortName: 'LED & LCD TV',
    priceRaw: '',
    price: null,
  },
  {
    id: 'B07B67ZMZL',
    title:
      'Amazon.com : La San Marzano Peeled Tomatoes with Basil Leaf 28 oz. (Pack of 3) - 100% Product of Italy : Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/San-Marzano-Peeled-Tomatoes-Basil/dp/B07B67ZMZL',
    largestImageUrl: '61UUADbDIiL._SL1000_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Canned, Jarred & Packaged Foods',
      'Vegetables',
      'Tomatoes',
      'Peeled',
    ],
    endCategory: 'Peeled',
    shortName: 'Peeled',
    priceRaw: '$17.98',
    price: 17.98,
  },
  {
    id: 'B07B9QTCMQ',
    title:
      'Amazon.com : The Oregon Stapler - Heavy Duty, Stapler Built in USA - Perfect for Home or Office Space - Staples 2 to 25 Sheets, Includes Box of Staples- by PraxxisPro (Red) : Office Products',
    url:
      'https://www.amazon.com/Oregon-Stapler-Perfect-Staples-PraxxisPro/dp/B07B9QTCMQ',
    largestImageUrl: '81gjfyCrunL._SL1500_.jpg',
    categories: [
      'Office Products',
      'Office & School Supplies',
      'Staplers & Punches',
      'Manual Staplers',
      'Desktop Staplers',
    ],
    endCategory: 'Desktop Staplers',
    shortName: 'Desktop Stapler',
    priceRaw: '$14.99',
    price: 14.99,
  },
  {
    id: 'B07C4B74CQ',
    title:
      'Amazon.com : Smoked Sprats in vegetable Oil, 5.6 Oz Tins with pull-tab, Riga Sprats : Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/Smoked-Sprats-vegetable-Tins-pull-tab/dp/B07C4B74CQ',
    largestImageUrl: '91miLTiJzhL._SL1500_.jpg',
    categories: [],
    endCategory: 'Grocery',
    shortName: 'Grocery',
    priceRaw: '$7.98',
    price: 7.98,
  },
  {
    id: 'B07CK4F81F',
    title:
      'Amazon.com: XOCARTIGE Tassel Earrings Thread Fringe Chandelier Drop Dangle Earrings Bohemia Beaded Disc Stud Earring for Women Girls (Blue): Home & Kitchen',
    url:
      'https://www.amazon.com/XOCARTIGE-Earrings-Chandelier-Bohemia-Earring/dp/B07CK4F81F',
    largestImageUrl: '71X41TlZBRL._UL1500_.jpg',
    categories: [
      'Clothing, Shoes & Jewelry',
      'Girls',
      'Jewelry',
      'Earrings',
      'Drop & Dangle',
    ],
    endCategory: 'Drop & Dangle',
    shortName: 'Drop & Dangle',
    priceRaw: '9.89',
    price: 9.89,
  },
  {
    id: 'B07CMZHG5N',
    title: 'Amazon.com | Nike Flex Experience RN 5 Running Shoe | Athletic',
    url:
      'https://www.amazon.com/Nike-Flex-Experience-Running-Shoe/dp/B07CMZHG5N',
    largestImageUrl: '81aaOrTfKZL._UL1500_.jpg',
    categories: ['Clothing, Shoes & Jewelry', 'Men', 'Shoes', 'Athletic'],
    endCategory: 'Athletic',
    shortName: 'Athletic',
    priceRaw: '$38.95 - $244.25',
    price: 244.25,
  },
  {
    id: 'B07CV55RRT',
    title:
      'Amazon.com: VWH 12pcs Rectangular Silicone Baking Cups Petite Loaf Pans Cupcake Muffin Molds: Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/VWH-Rectangular-Silicone-Baking-Cupcake/dp/B07CV55RRT',
    largestImageUrl: '61wEJoA-RCL._SL1100_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Bakeware',
      'Muffin & Cupcake Pans',
    ],
    endCategory: 'Muffin & Cupcake Pans',
    shortName: 'Muffin & Cupcake Pan',
    priceRaw: '$3.07',
    price: 3.07,
  },
  {
    id: 'B07CZM7YWP',
    title:
      "Amazon.com: O'Neill's Shamrock Shaped Shortbread in A Tin 80G: Grocery & Gourmet Food",
    url:
      'https://www.amazon.com/ONeills-Shamrock-Shaped-Shortbread-Tin/dp/B07CZM7YWP',
    largestImageUrl: '819EVWafK6L._UL1134_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Snack Foods',
      'Cookies',
      'Shortbread',
    ],
    endCategory: 'Shortbread',
    shortName: 'Shortbread',
    priceRaw: '$5.90',
    price: 5.9,
  },
  {
    id: 'B07D2D7HLP',
    title:
      'Berrylion Pro Wire Cutter - Side Cutting/Diagonal Plier 7-inch Insulated Chrome Vanadium Steel - - Amazon.com',
    url:
      'https://www.amazon.com/Berrylion-Pro-Wire-Cutter-Insulated/dp/B07D2D7HLP',
    largestImageUrl: '71zWQbLwt5L._SL1500_.jpg',
    categories: [
      'Tools & Home Improvement',
      'Power & Hand Tools',
      'Hand Tools',
      'Cutters',
      'Wire Cutters',
    ],
    endCategory: 'Wire Cutters',
    shortName: 'Wire Cutter',
    priceRaw: '$15.89',
    price: 15.89,
  },
  {
    id: 'B07D7XGGYM',
    title:
      "Joyaria Women's Super Soft Pajama Set Button Down Pjs Long Sleeve Sleepwear (Black, Medium) at Amazon Women’s Clothing store:",
    url:
      'https://www.amazon.com/Joyaria-Womens-Button-Viscose-Sleepwear/dp/B07D7YD4MK',
    largestImageUrl: '61AISUCTvPL._UL1500_.jpg',
    categories: [
      'Clothing, Shoes & Jewelry',
      'Women',
      'Clothing',
      'Lingerie, Sleep & Lounge',
      'Sleep & Lounge',
      'Sets',
    ],
    endCategory: 'Sets',
    shortName: 'Set',
    priceRaw: '$36.99',
    price: 36.99,
  },
  {
    id: 'B07DBPKLM3',
    title:
      'Amazon.com : CEMXX One-Piece Athletic Leotards for Girls Gymnastics Sparkly Unicorn Unitards Cartoon Ballet Dancing Biketards(Hotpink, 110 for 4-5Y) : Clothing',
    url:
      'https://www.amazon.com/CEMXX-One-Piece-Athletic-Gymnastics-Biketards/dp/B07DBNHG8J',
    largestImageUrl: '81TZ9tpBxmL._SL1500_.jpg',
    categories: [
      'Sports & Outdoors',
      'Sports & Fitness',
      'Other Sports',
      'Dance',
      'Clothing',
      'Girls',
      'Leotards',
    ],
    endCategory: 'Leotards',
    shortName: 'Leotard',
    priceRaw: '13.69',
    price: 13.69,
  },
  {
    id: 'B07DNP9ZKH',
    title:
      'Amazon.com : WADEO Athletic Bras for Women High Support Racerback Sports Bra Padded for Workout Fitness Yoga Gym - Small : Clothing',
    url:
      'https://www.amazon.com/WADEO-Athletic-Support-Racerback-Workout/dp/B07GRJ6TD6',
    largestImageUrl: '71EKSq1yRrL._SL1000_.jpg',
    categories: [
      'Clothing, Shoes & Jewelry',
      'Women',
      'Clothing',
      'Lingerie, Sleep & Lounge',
      'Lingerie',
      'Bras',
      'Sports Bras',
    ],
    endCategory: 'Sports Bras',
    shortName: 'Sports Bra',
    priceRaw: '7.99',
    price: 7.99,
  },
  {
    id: 'B07DQSNMMW',
    title:
      'Black Tobiko - Frozen Flying Fish Roe - (7 oz): Amazon.com: Grocery & Gourmet Food',
    url: 'https://www.amazon.com/Black-Tobiko-Frozen-Flying-Fish/dp/B07DQSNMMW',
    largestImageUrl: '71TlnDfrwdL._SL1000_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Meat & Seafood',
      'Seafood',
      'Caviars & Roes',
    ],
    endCategory: 'Caviars & Roes',
    shortName: 'Caviars & Roe',
    priceRaw: '$20.00',
    price: 20,
  },
  {
    id: 'B07DY7PNQK',
    title:
      'SNICKERS Ice Cream Cone Singles - 4 oz (72 Count): Amazon.com: Grocery & Gourmet Food',
    url: 'https://www.amazon.com/SNICKERS-Ice-Cream-Cone-Singles/dp/B07DY7PNQK',
    largestImageUrl: '71UQ23ToVhL._SL1500_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Frozen',
      'Ice Cream & Novelties',
      'Ice Cream',
    ],
    endCategory: 'Ice Cream',
    shortName: 'Ice Cream',
    priceRaw: '$118.69',
    price: 118.69,
  },
  {
    id: 'B07FFVT6KG',
    title:
      'Amazon.com: 5 Pack 24 Inch Drain Snake,AUSAYE Hair Cather Shower Drain Hair Trap Cleaner Drain Clog Remover: Health & Personal Care',
    url:
      'https://www.amazon.com/AUSAYE-Cather-Shower-Cleaner-Remover/dp/B07FFVT6KG',
    largestImageUrl: '611p6ewkkBL._SL1000_.jpg',
    categories: [
      'Tools & Home Improvement',
      'Rough Plumbing',
      'Drain Cleaning Equipment',
    ],
    endCategory: 'Drain Cleaning Equipment',
    shortName: 'Drain Cleaning Equipment',
    priceRaw: '$5.29',
    price: 5.29,
  },
  {
    id: 'B07G5W86K4',
    title:
      'Amazon.com | BonNoces 3-Tier Porcelain Embossed Cake Stand - Assorted Colors Fine Elegant Dessert Cupcake Stand - Pastry Serving Tray Platter for Tea Party, Wedding and Birthday: Cake Stands',
    url:
      'https://www.amazon.com/BonNoces-3-Tier-Porcelain-Embossed-Stand/dp/B07G5W86K4',
    largestImageUrl: '71zA4GJrUrL._SL1500_.jpg',
    categories: [
      'Home & Kitchen',
      'Kitchen & Dining',
      'Dining & Entertaining',
      'Serveware',
      'Cake Stands',
    ],
    endCategory: 'Cake Stands',
    shortName: 'Cake Stand',
    priceRaw: '$19.99',
    price: 19.99,
  },
  {
    id: 'B07GV41JJH',
    title:
      "Amazon.com: 15' Feet Telephone Extension Cord Cable Line Wire, White RJ-11 by True Decor: Electronics",
    url:
      'https://www.amazon.com/Telephone-Extension-Cable-True-Decor/dp/B07GV41JJH',
    largestImageUrl: '61Z06BvWiNL._SL1000_.jpg',
    categories: [
      'Electronics',
      'Accessories & Supplies',
      'Telephone Accessories',
      'Line Cords',
    ],
    endCategory: 'Line Cords',
    shortName: 'Line Cord',
    priceRaw: '$5.69',
    price: 5.69,
  },
  {
    id: 'B07GVB69W9',
    title:
      'Amazon.com: 1000PCS (500Pairs) Self Adhesive Dots, Karvipark Hook Loop Sticky, Waterproof, Durable Fastener Dots in Arts, Crafts, Sewing (Black)',
    url:
      'https://www.amazon.com/500Pairs-Adhesive-Karvipark-Waterproof-Fastener/dp/B07GVB69W9',
    largestImageUrl: '81zZKmpPVxL._SL1500_.jpg',
    categories: [
      'Arts, Crafts & Sewing',
      'Sewing',
      'Sewing Notions & Supplies',
      'Fasteners',
      'Interlocking Tape',
    ],
    endCategory: 'Interlocking Tape',
    shortName: 'Interlocking Tape',
    priceRaw: '12.99',
    price: 12.99,
  },
  {
    id: 'B07H4JR4SQ',
    title:
      'Amazon.com: Gaiatop Chip Maker, The DIY Microwave Oven Baked Potato Chips Home Baking Tool: Grocery & Gourmet Food',
    url:
      'https://www.amazon.com/Gaiatop-Maker-Microwave-Potato-Baking/dp/B07H4JR4SQ',
    largestImageUrl: '61IL7YOeLAL._SL1500_.jpg',
    categories: [
      'Grocery & Gourmet Food',
      'Snack Foods',
      'Chips & Crisps',
      'Potato',
    ],
    endCategory: 'Potato',
    shortName: 'Potato',
    priceRaw: '7.48',
    price: 7.48,
  },
  {
    id: 'B07HF2C8VV',
    title:
      'Amazon.com: Funnywhale Umbrella|10 Ribs Automatic Umbrella|95% UV Protection Umbrella |60 MPH Windproof Umbrella|45.7 in Golf Umbrella|Lightweight and Compact Folding Umbrella (Dark Black): Sports & Outdoors',
    url:
      'https://www.amazon.com/Funnywhale-Automatic-Protection-Windproof-Lightweight/dp/B07HF2C8VV',
    largestImageUrl: '61WICoY5VXL._SL1500_.jpg',
    categories: [
      'Clothing, Shoes & Jewelry',
      'Luggage & Travel Gear',
      'Umbrellas',
      'Stick Umbrellas',
    ],
    endCategory: 'Stick Umbrellas',
    shortName: 'Stick Umbrella',
    priceRaw: '$9.88',
    price: 9.88,
  },
  {
    id: 'B07HFG93GK',
    title:
      'Amazon.com: AquaSonic DUO - Dual Handle Ultra Whitening Electric ToothBrushes - 40,000 VPM Motor & Wireless Charging - 3 Modes with Smart Timers - 10 DuPont Brush Heads & 2 Travel Cases Included: Beauty',
    url:
      'https://www.amazon.com/AquaSonic-DUO-Whitening-Electric-ToothBrushes/dp/B07HFG93GK',
    largestImageUrl: '71WNo9626pL._SL1500_.jpg',
    categories: [
      'Industrial & Scientific',
      'Professional Dental Supplies',
      'Oral Hygiene & Preventive Care',
      'Toothbrushes',
    ],
    endCategory: 'Toothbrushes',
    shortName: 'Toothbrush',
    priceRaw: '$46.95',
    price: 46.95,
  },
  {
    id: 'B07JH2TSQH',
    title:
      'Amazon.com: Justrite 7250130 Galvanized Steel, AccuFlow Type II Red Safety Can 1" Flexible Spout, Large ID Zone, Meets OSHA & NFPA Handling Hazardous Liquids. 5 Gallon (19L) Size: Industrial & Scientific',
    url:
      'https://www.amazon.com/Justrite-Galvanized-AccuFlow-Flexible-Hazardous/dp/B07JH2TSQH',
    largestImageUrl: '71rwYp2BjQuL._SL1500_.jpg',
    categories: [
      'Patio, Lawn & Garden',
      'Outdoor Power Tools',
      'Replacement Parts & Accessories',
      'Gas Cans',
    ],
    endCategory: 'Gas Cans',
    shortName: 'Gas Can',
    priceRaw: '$64.95 - $464.80',
    price: 464.8,
  },
];

export { itemsRaw };
